/**
 * @author Fernando Ruano
 * @file actions.js
 * @description Patient Appointments Actions
 */

// Constants
import {
  SCHEDULE_APPOINTMENT_ZOOM,
  CANCEL_APPOINTMENT_ZOOM,
  RESCHEDULE_APPOINTMENT_ZOOM,
  GET_ZOOM_VIDEO_CALL_BY_ID,
  GET_MULTIPLE_ZOOM_VIDEO_CALL_BY_ID
} from './constants';

/**
 * Call process to schedule patient appointments
 * @param  { object } data - Patient Appointments Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of SCHEDULE_APPOINTMENT_ZOOM
 */
export const scheduleAppointmentZoom = (data, callback) => ({
  type: SCHEDULE_APPOINTMENT_ZOOM,
  payload: { data },
  callback
});

/**
 * Call process to reschedule patient appointments
 * @param  { object } data - Patient Appointments Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of RESCHEDULE_APPOINTMENT_ZOOM
 */
export const reScheduleAppointmentZoom = (data, callback) => ({
  type: RESCHEDULE_APPOINTMENT_ZOOM,
  payload: { data },
  callback
});

/**
 * Call process to cancel patient appointments
 * @param  { object } data - Patient Appointments Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CANCEL_APPOINTMENT_ZOOM
 */
export const cancelAppointmentZoom = (data, callback) => ({
  type: CANCEL_APPOINTMENT_ZOOM,
  payload: { data },
  callback
});

/**
 * Call process to get zoom meeting id by appointment Id
 * @param  { object } data - Appointments Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_VIDEO_CALL_BY_ID
 */
export const getZoomVideoCallById = (data, callback) => ({
  type: GET_ZOOM_VIDEO_CALL_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to get zoom meeting by multiple appointment Id
 * @param  { object } data - Appointments array
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_MULTIPLE_ZOOM_VIDEO_CALL_BY_ID
 */
export const getMultipleZoomVideoCallById = (data, callback) => ({
  type: GET_MULTIPLE_ZOOM_VIDEO_CALL_BY_ID,
  payload: { data },
  callback
});
